export enum FileUploadModes {
  Combined = 'Combined',
  Separate = 'Separate',
}
